import React from 'react'
export const ChallengeStatusBadge = ({ statusStr, statusCol, classes }) => (
    <figure className={classes.status} style={{ backgroundColor: statusCol }}>
      <figcaption>{statusStr}</figcaption>
    </figure>
  );
  